<div
  class="modal fade"
  id="staticPrivacyBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticPrivacyBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close button"
          aria-label="Close"
          id="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>
      <div class="modal-body">
        <h4>Privatnost</h4>
        <p>
          MAX BET DOO BEOGRAD, sa sedištem u ulici Bulevar heroja sa Košara 4a, Beograd (u daljem
          tekstu: MaxBet) je u agenciji za privredne registre u Srbiji zavedena pod brojem 07854293
          priređuje Igre na sreću preko sredstava elektronske komunikacije u skladu sa odobrenjem
          br. 000-424-00-00317/2015 , izdatim od strane Ministarstva finansija Republike Srbije -
          Poreska uprava - sektora za menjačke i devizne poslove i igre na sreću, se obavezuje da
          štiti i poštuje privatnost registrovanih korisnika. Podaci koji su dostavljeni za
          registraciju od korisnika se čuvaju u tajnosti za naše svrhe radi korišćenja Maxbet Web
          servisa, i služe samo za namenu za koju se daju. Ove podatke MaxBet ne razmenjuje sa
          trećim licima. Mail adrese se mogu koristiti jedino za to da se našim registrovanim
          korisnicima dostave informacije o uslugama koje pruža MaxBet. Podaci se mogu dati trećim
          licima isključivo ukoliko to nalože državni organi, za potrebe sudskih postupaka i u
          drugim slučajevima, a sve u skladu sa zakonom ili drugim propisom.
        </p>

        <h4>Prikupljanje informacija</h4>
        <p>
          Saglasni ste sa prikupljanjem, prenosom i čuvanjem tih informacija od strane Priređivača.
          Informacije i podaci o Vama koje možemo prikupljati, koristiti i obrađivati obuhvataju
          sledeće:
        </p>
        <ol>
          <li>Informacije koje nam prosleđujete preko aplikacije ili elektronskom poštom;</li>
          <li>
            Evidencija o komunikaciji, bilo putem aplikacije, elektronske pošte, telefona ili drugih
            sredstava;
          </li>
          <li>Vaši odgovori na ankete ili ispitivanja korisnika koja sprovodimo;</li>
          <li>
            Detalji o Vašim posetama aplikaciji, uključujući, između ostalog, domen i host preko
            koga pristupate internetu, Vašu IP adresu, pretraživač, operativni sistem i poseban
            softver koji koristite, vreme i datum Vašeg pristupa, URL lokacije preko čije spoljne
            veze dolazite na našu aplikaciju kada nas posećujete, podatke o lokaciji, veblogovima i
            ostale podatke vezane za komunikaciju. Takođe, možemo prikupljati informacije u vezi sa
            Vašim aktivnostima vezanim za korišćenjem našeg proizvoda;
          </li>
          <li>
            Informacije mogu obuhvatati ime i prezime, adresu, adresu elektronske pošte, mesto
            stanovanja, pol, nadimak, konfekcijski broj i broj telefona, informacije o obliku
            identifikacije koji se koristi, a sve u skladu sa važećim propisima.
          </li>
        </ol>
        <h4>Korišćenje informacija</h4>
        <p>
          Vaše lične podatke i informacije zajedno sa ostalim informacijama možemo koristiti u
          sledeće svrhe:
        </p>
        <ol>
          <li>Obrada Vaših opklada;</li>
          <li>Otvaranje, rukovođenje i upravljanje Vašim online nalogom;</li>
          <li>
            Potvrđivanje bilo koje informacije koju prosledite kako bismo postigli, vodili i očuvali
            kontinuitet svih aktivnosti na online nalogu;
          </li>
          <li>
            Poštovanje zakonskih obaveza uključujući i one čiji je cilj sprečavanje pranja novca;
          </li>
          <li>Izrada ličnih profila;</li>
          <li>Sprovođenje ispitivanja korisnika, anketa i analiza;</li>
          <li>
            Upućivanje informacija o promotivnim ponudama i o našim proizvodima i usluga, ukoliko
            ste za to dali svoj pristanak;
          </li>
          <li>
            Praćenje transakcija u okviru online naloga u cilju sprečavanja nepropisnog klađenja,
            pranja novca i varanja;
          </li>
          <li>
            Stavljanje na raspolaganje proizvoda i usluga i pomoć u pružanju istih, kao i pomoć u
            razvoju i poboljšanju usluga;
          </li>
          <li>
            Čuvanje Vaših ličnih podešavanja, preferencija i drugih informacija i praćenje
            konkretnih aktivnosti na našoj aplikaciji;
          </li>
          <li>Sticanje uvida u efektivnost naših promotivnih kampanja;</li>
          <li>Utvrđivanje izvora sa koga ste pristupili našoj aplikaciji</li>
          <li>Vođenje aplikacije i poboljšanje korisničkog iskustva i upravljanje poslovanjem.</li>
        </ol>
        <h4>Politika kolačića i internet tehnologija</h4>
        <p>
          Kolačići su male tekstualne datoteke koje dospevaju na Vaš računar tako što posećujete
          određene vebsajtove ili otvarate određene poruke u elektronskoj pošti. Njihovo korišćenje
          je rasprostranjeno i namenjeno poboljšanju rada vebsajtova ili samom funkcionisanju istih,
          i to u cilju efikasnijeg pružanja poslovnih ili marketinških informacija. Korisnik može
          upravljati kolačićima (podešavanjima). Ispisuju se ili očitavaju isključivo oni kolačići
          koji se zasnivaju na preferencijama korisnika. Ukoliko Vaš pretraživač ne podržava
          JavaScript, korišćenjem kolačića možete upravljati isključivo preko podešavanja Vašeg
          internet pretraživača. Obratite pažnju na to da ukoliko deaktivirate sve kolačiće preko
          Vašeg pretraživača, to može ograničiti funkcionalnost opcija na aplikaciji.
        </p>
        <h4>Odavanje informacija</h4>
        <p>
          MaxBet će preduzeti sve neophodne korake u cilju očuvanja Vaših informacija bezbednim i
          zaštićenim. Prikupljanje Vaših podataka koji su Vam traženi i sa čime ste se saglasili se
          vrši u skladu sa zakonom i podaci koje ste nam dali se mogu koristiti isključivo za
          poboljšanje naših usluga. Prikupljeni podaci će biti dostupni regulatornim, sportskim i
          drugim nadležnim organima, uključujući policiju, u cilju sprovođenja istražnih radnji
          vezanih za prevare, pranje novca ili probleme sa integritetom u sportu, kao i radi
          poštovanja naših zakonskih obaveza.
        </p>
        <br />
        <h4>Povlačenje saglasnosti</h4>
        <p>
          Imate pravo da povučete saglasnost o korišćenju u svakom trenutku, tako što ćete nam se
          obratiti tim povodom. Odmah po povlačenju korisnikove saglasnosti, prestaćemo sa
          korišćenjem pomenutih informacija osim ukoliko nam zakon ne nalaže da nastavimo sa
          njihovim korišćenjem. U evidenciji čuvamo korisničku istoriju (aktivnost na online nalogu)
          u skladu sa našom politikom o čuvanju podataka. Nakon isteka predviđenog perioda, Vaše
          informacije trajno će biti uklonjene. Lice za zaštitu podataka o ličnosti kod Rukovaoca:
        </p>
        Email: dpo&#64;maxbet.rs
        <p>Kontakt telefon: 062/515-497</p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn--close"
          id="btn-ok"
          data-bs-dismiss="modal"
          data-bs-dismiss="modal"
          (click)="this.dialogService.closeDialog()"
        >
          U redu
        </button>
      </div>
    </div>
  </div>
</div>
